module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      'withBorderBottom': _vm.withBorderBottom
    },
    attrs: {
      "id": "top-bar"
    }
  }, [_c('div', {
    staticClass: "container flex"
  }, [_c('div', [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "42px"
    },
    attrs: {
      "src": "//official.cdn.qiyewan.com/logo.png",
      "title": "企业湾",
      "alt": "企业湾logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "location"
    },
    on: {
      "mouseenter": function($event) {
        _vm.isShowing = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon_location.png"),
      "alt": "location"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#0ca6ea"
    }
  }, [_vm._v(_vm._s(_vm.getRegion.name))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    class: {
      'active': _vm.isShowing
    },
    attrs: {
      "id": "area"
    }
  }, [_c('ul', [_c('p'), _vm._v(" "), _vm._l((_vm.getRegions), function(item, index) {
    return _c('li', {
      class: {
        active: index === _vm.getRegionIndex
      },
      attrs: {
        "title": item.remarks
      },
      on: {
        "click": function($event) {
          _vm.changeRegion(item.code)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")])
  })], 2)])])]), _vm._v(" "), _c('zj-search'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "header-user-block"
    }
  }, [(_vm.isLogin) ? _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/cart"
    }
  }, [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/card.png",
      "alt": "cart"
    }
  }), _vm._v("购物车")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/order"
    }
  }, [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/order.png",
      "alt": "order"
    }
  }), _vm._v("订单")])], 1), _vm._v(" "), _c('li', {
    staticClass: "person_cen"
  }, [_c('router-link', {
    staticStyle: {
      "padding-right": "0!important"
    },
    attrs: {
      "to": "/person"
    }
  }, [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/user.png",
      "alt": ""
    }
  }), _vm._v("个人中心\n            ")]), _vm._v(" "), _c('img', {
    staticClass: "up",
    attrs: {
      "src": "//v3.cdn.qiyewan.com/tuichu.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logout"
  }, [_c('a', {
    staticStyle: {
      "margin": "1px 0",
      "text-align": "center"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": (_vm.acctApi + "/register?referer=" + _vm.curPath)
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": (_vm.acctApi + "?referer=" + _vm.curPath)
    }
  }, [_vm._v("登录")])])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "ci-right"
  }, [_c('s', [_vm._v("◆")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-32b2b7e6!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBar.vue
// module id = 1027
// module chunks = 40